export const removeGiftCardFromPayment = (form, piId) => {
    form.giftCardProcessingType.value = 'remove';
    form.piId.value = piId;
    form.submit();
};
